module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-como-01.7dcf9c95.jpg";